import React from "react";
import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { MAX_FAVORITES } from "../../constants/fanPage";
import { colors } from "../../theme";
import { horizontalScroll } from "../home/homeStyles";
import LineupSlot from "./LineupSlot";

const FavoritesStrip = ({
  favorites = [],
  editable = false,
  onSelect,
  onClear,
  onAdd,
}) => {
  const canAdd = editable && favorites.length < MAX_FAVORITES;

  return (
    <Box>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>
        Favorites
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Players you love who didn’t have to crack the nine.
      </Typography>
      <Box sx={horizontalScroll}>
        {favorites.map((player) => (
          <LineupSlot
            key={player.playerId}
            slot={{ id: player.playerId, short: "FAV", label: "Favorite" }}
            player={player}
            editable={editable}
            size="favorite"
            showPosition={false}
            onSelect={() => onSelect(player)}
            onClear={() => onClear(player)}
          />
        ))}
        {canAdd && (
          <Box
            onClick={onAdd}
            sx={{
              width: 92,
              minHeight: 120,
              borderRadius: 2,
              border: `1px dashed ${colors.border}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              cursor: "pointer",
              color: "text.secondary",
              flexShrink: 0,
              "&:hover": {
                borderColor: "primary.main",
                color: "text.primary",
              },
            }}
          >
            <AddIcon />
            <Typography variant="caption">Add player</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FavoritesStrip;
